import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import apiClient from "../utils/apiClient";

const InputBlock = styled.div`
  position: relative;
  & > p {
    margin: 0;
    font-size: 12px;
    color: #000000;
    padding-bottom: 8px;
  }
  & > input {
    font-size: 14px;
    border: 1px solid #d1d3d4;
    border-radius: 4px;
    width: 100%;
    height: 41px;
    padding-inline-start: 12px;
    box-sizing: border-box;
  }
  & > select {
    font-size: 14px;
    border: 1px solid #d1d3d4;
    border-radius: 4px;
    width: 100%;
    height: 41px;
    padding-inline-start: 12px;
    box-sizing: border-box;
  }
`;

const StyledInput = styled.input`
  width: 100%;
  padding: 5px;

  &:focus {
    outline: none;
    border-color: #4caf50;
    box-shadow: 0 0 0 1px #4caf50;
  }
`;

const ManagerAutocomplete = ({ value, onChange, onSelect }) => {
  const [options, setOptions] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  // Флаг для выполнения первичной синхронизации
  const initialSyncDoneRef = useRef(false);

  console.log("value", value);

  useEffect(() => {
    const fetchWorkers = async () => {
      try {
        const res = await apiClient.get("/data/GetHandbook", {
          params: { type: "workers" },
        });
        const workers = res.data.select.map((item) => {
          const parts = item.title.split("|");
          return { label: parts[0], value: item.id };
        });
        setOptions(workers);
      } catch (error) {
        console.error("Ошибка получения списка менеджеров:", error);
      }
    };
    fetchWorkers();
  }, []);

  // При первой загрузке опций, если value уже задан, ищем совпадение и вызываем onChange/onSelect один раз.
  useEffect(() => {
    if (!initialSyncDoneRef.current && value && options.length > 0) {
      const matchingOption = options.find(
        (option) =>
          option.label.toLowerCase() === value.toLowerCase() ||
          String(option.value) === String(value),
      );
      console.log("matchingOption", matchingOption);
      if (matchingOption) {
        if (matchingOption.label !== value) {
          onChange(matchingOption.label);
        }

        if (typeof onSelect === "function") {
          onSelect(matchingOption);
        }
        setTimeout(() => {
          setFiltered([]);
          setShowDropdown(false);
        }, 1000);

        initialSyncDoneRef.current = true;
      }
    }
  }, [value, options, onChange, onSelect]);

  useEffect(() => {
    if (value) {
      const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(value.toLowerCase()),
      );
      setFiltered(filteredOptions);
      setShowDropdown(true);
    } else {
      setFiltered([]);
      setShowDropdown(false);
    }
  }, [value, options]);

  return (
    <InputBlock>
      <StyledInput
        type="text"
        value={value}
        onChange={(e) => {
          // При изменении значения сбрасываем флаг синхронизации, чтобы при необходимости можно было повторно синхронизировать
          initialSyncDoneRef.current = false;
          onChange(e.target.value);
        }}
        onFocus={() => setShowDropdown(true)}
        onBlur={() => {
          setTimeout(() => setShowDropdown(false), 100);
        }}
      />
      {showDropdown && filtered.length > 0 && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            background: "#fff",
            border: "1px solid #ccc",
            maxHeight: "150px",
            overflowY: "auto",
            margin: 0,
            padding: 0,
            listStyle: "none",
            zIndex: 1000,
          }}
        >
          {filtered.map((option) => (
            <li
              key={option.value}
              style={{ padding: "5px", cursor: "pointer" }}
              onMouseDown={() => {
                onChange(option.label);
                if (typeof onSelect === "function") {
                  onSelect(option);
                }
                setShowDropdown(false);
              }}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </InputBlock>
  );
};

export default ManagerAutocomplete;
